'use client';

import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';

const CTA_SELECTOR = '[data-marketing-auth-cta]';
const MOBILE_CTA_SELECTOR = '[data-marketing-auth-mobile-cta]';

export function StaticPageLayoutAuthHydrator(): null {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    const updateLink = (element: HTMLAnchorElement | null): void => {
      if (!element) {
        return;
      }

      const { href: defaultHref, textContent } = element;
      const readDataAttribute = (name: string) => {
        const value = element.getAttribute(`data-${name}`);
        return value && value.length > 0 ? value : undefined;
      };
      const loginClass = readDataAttribute('login-class');
      const authClass = readDataAttribute('auth-class') ?? loginClass;
      const authHref = readDataAttribute('auth-href') ?? defaultHref;

      const loginHrefAttribute = element.getAttribute('href');
      const loginHref = readDataAttribute('login-href') ?? loginHrefAttribute ?? '/auth/signin';
      const authLabel = readDataAttribute('auth-label') ?? textContent ?? 'Open Timeline';
      const loginLabel = readDataAttribute('login-label') ?? textContent ?? 'Login';

      if (isAuthenticated) {
        if (authClass) {
          element.className = authClass;
        }
        element.href = authHref;
        element.textContent = authLabel;
        return;
      }

      if (loginClass) {
        element.className = loginClass;
      }
      element.href = loginHref;
      element.textContent = loginLabel;
    };

    const primaryCta = document.querySelector<HTMLAnchorElement>(CTA_SELECTOR);
    const mobileCta = document.querySelector<HTMLAnchorElement>(MOBILE_CTA_SELECTOR);

    updateLink(primaryCta);
    updateLink(mobileCta);
  }, [isAuthenticated]);

  return null;
}
